import {
  VIEWING_DOCUMENT_ACCEPTED_TYPES,
  VIEWING_DOCUMENT_MAX_SIZE,
} from './RentalPortalViewingProfileDocumentUploadModal.constants'

export function getViewingDocumentDropzoneOptions() {
  return {
    accept: VIEWING_DOCUMENT_ACCEPTED_TYPES,
    maxSize: VIEWING_DOCUMENT_MAX_SIZE,
    multiple: true,
  }
}
